import T from "@marginly/ui/components/typography";

import Space from "../../common/space";
import {
  Precious,
  PreciousBar,
  PreciousRow,
  PreciousThumb,
  PreciousWrapper,
} from "../styled";

const PreciousBlock = () => {
  return (
    <PreciousWrapper>
      <Precious>
        <T headerL>
          Sparks are <span className="accent">precious</span>
        </T>
        <Space height={38} heightMobile={24} />

        <PreciousRow>
          <PreciousThumb>
            <img src="/images/airdrop/chart.png" alt="" />
          </PreciousThumb>
          <T body>Improve APYs and liquidity depth</T>
        </PreciousRow>
        <Space height={32} heightMobile={32} />

        <PreciousRow>
          <PreciousThumb>
            <img src="/images/airdrop/flash.png" alt="" />
          </PreciousThumb>
          <T body>Boost partnerships</T>
        </PreciousRow>
        <Space height={32} heightMobile={32} />

        <PreciousRow>
          <PreciousThumb>
            <img src="/images/airdrop/pairs.png" alt="" />
          </PreciousThumb>
          <T body>Facilitate new pool launches</T>
        </PreciousRow>
        <Space height={32} heightMobile={24} />

        <PreciousBar>
          <img src="/images/airdrop/users.png" alt="" />
          <T body>Spark farmers will become the first Marginly token holders</T>
        </PreciousBar>
      </Precious>
    </PreciousWrapper>
  );
};

export default PreciousBlock;
